import React from 'react';
import { InfinityIcon, LockIcon, ZapIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { CTA_LABEL, PRICE, PRICE_CURRENCY, TOTAL_VALUE } from '../data/content';
const perks = [{
  icon: ZapIcon,
  label: 'Acceso inmediato'
}, {
  icon: InfinityIcon,
  label: 'Pago único, acceso de por vida'
}, {
  icon: LockIcon,
  label: 'Compra segura'
}];
export function PricingSection() {
  return <section id="comprar" className="border-b border-ink-700 bg-ink-900 scroll-mt-4" data-id="element-108" data-mp="1n9ioa2eyqk9c">
      <div className="mx-auto max-w-4xl px-5 py-14 sm:py-20" data-id="element-109" data-mp="1s93wz4jxq6z9">
        <p className="mb-3 text-center text-xs font-bold uppercase tracking-[0.22em] text-shield-500" data-id="element-110" data-mp="1sbgejgls6fbs">
          Precio especial de lanzamiento
        </p>
        <h2 className="mx-auto mb-8 max-w-2xl text-center font-display text-2xl font-extrabold leading-tight tracking-tight text-white sm:text-4xl" data-id="element-111" data-mp="226rs3vlgdghy">
          No quiero que el precio sea la razón por la que te quedes desprotegido.
        </h2>

        <div className="mx-auto max-w-xl rounded-3xl border border-shield-500/40 bg-ink-800 p-6 text-center sm:p-9" data-id="element-112" data-mp="7vmv3a4vg2bl">
          <p className="text-sm text-slate-400" data-id="element-113" data-mp="1hq7zlmeatfvv">
            Todo el material por menos de lo que sale un envío de delivery
          </p>
          <p className="mt-4 text-base font-semibold text-slate-500 line-through" data-id="element-114" data-mp="1crmzdmz1qw7f">{TOTAL_VALUE}</p>
          <p className="mt-1 font-display text-5xl font-extrabold tracking-tight text-shield-500 sm:text-6xl" data-id="element-115" data-mp="17t3b3fwzd8bw">
            {PRICE}
            <span className="ml-2 align-middle text-lg font-bold text-slate-400" data-id="element-116" data-mp="25dg3q0zzqiwb">
              {PRICE_CURRENCY}
            </span>
          </p>
          <p className="mt-2 text-sm font-semibold uppercase tracking-widest text-slate-400" data-id="element-117" data-mp="1vgl9huar34nu">
            Pago único · Acceso de por vida
          </p>

          <div className="mt-7 flex justify-center" data-id="element-118" data-mp="1rhu7p9vcayue">
            <CtaButton label={CTA_LABEL} sublabel="Descarga al instante" data-id="element-119" data-mp="k39073w81tua" />
          </div>

          <ul className="mt-7 flex flex-wrap items-center justify-center gap-x-6 gap-y-3 border-t border-ink-700 pt-6" data-id="element-120" data-mp="g0cntux9ytys">
            {perks.map(({
            icon: Icon,
            label
          }) => <li key={label} className="flex items-center gap-2 text-xs text-slate-400 sm:text-sm" data-id="element-121" data-mp="mhe636xwkdvy">
                <Icon className="h-4 w-4 text-safe-500" aria-hidden="true" data-id="element-122" data-mp="7kddl17w0ewf" />
                {label}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}